import { FileIcon } from 'lucide-react';
import { IPostAttachment } from '@/redux/post/post.d';
import { CarouselItem } from '../ui/carousel';
import Vetric from '../Icons/FileIcons/Vetric';
import carvecoIcon from '../Icons/FileIcons/carveco.png';

const getSoftwareToLink = (extension: string) => {
  switch (extension) {
    case 'art':
      return 'https://www.onefinitycnc.com/shop/category/software';
    case 'crv':
      return 'https://www.onefinitycnc.com/shop/category/software';
    default:
      return undefined;
  }
};

function NotSupportedFileIcon({ extension }: { extension: string }) {
  // move this to mimetype based when possible
  switch (extension) {
    case 'art':
      return (
        <img src={carvecoIcon} alt={extension} className="h-[100px] w-auto" />
      );
    case 'crv':
      return <Vetric />;
    case 'crv3d':
      return <Vetric />;
    default:
      return <FileIcon width="50" height="50" />;
  }
}

function GetSupportedSoftware({ extension }: { extension: string }) {
  const softwareLink = getSoftwareToLink(extension);

  if (!softwareLink) {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <></>;
  }

  return (
    <p className="font-secondary text-md">
      Looking to view/work with this file. Get the supported software{' '}
      <a
        href={softwareLink}
        target="_blank"
        rel="noreferrer"
        className="underline text-blue-600"
      >
        here
      </a>
    </p>
  );
}

function NotSupportedCarouselItem({
  attachment,
}: {
  attachment: IPostAttachment;
}) {
  const extension = attachment.fileName.split('.')[1];
  const softwareLink = getSoftwareToLink(extension);
  return (
    <CarouselItem className="h-full flex items-center justify-center bg-gray-200 rounded-md">
      <div className="flex flex-col gap-3 items-center">
        {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
        <a href={softwareLink} target="_blank" rel="noreferrer">
          <NotSupportedFileIcon extension={extension} />
        </a>
        <h1 className="font-primary text-xl">
          This media format cannot be displayed here
        </h1>
        <GetSupportedSoftware extension={extension} />
      </div>
    </CarouselItem>
  );
}

export default NotSupportedCarouselItem;
